import React from "react";
import { Row, Col } from "antd";
import Style from "./examInfo.module.scss";
import {
    getExamTypeString,
    getRightAnswerCount,
    toFixedNumber
} from "../../utils/filter";

interface IExamInfo {
    score: string;
    list: {
        topicType: string;
        list: any[];
    }[];
}

const ExamInfo = ({ list, score }: IExamInfo) => {
    return (
        <div className={Style.main}>
            <h2 className={Style.score}>得分：{toFixedNumber(score)}分</h2>
            <Row className={`${Style.title} ${Style.item}`}>
                <Col span={12}>题目</Col>
                <Col span={12}>得分</Col>
            </Row>
            {list.map(item => {
                let score = getRightAnswerCount(item.list, item.topicType);
                return (
                    <Row key={item.topicType} className={Style.item}>
                        <Col span={12}>{`${getExamTypeString(
                            item.topicType
                        )}题`}</Col>
                        <Col span={12}>{toFixedNumber(score) || 0}</Col>
                    </Row>
                );
            })}
        </div>
    );
};

export default ExamInfo;
